'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountType = exports.UINT256_MAX = exports.RAD = exports.RAY = exports.WAD = exports.WEI = undefined;

var _bignumber = require('bignumber.js');

var _bignumber2 = _interopRequireDefault(_bignumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WEI = exports.WEI = new _bignumber2.default('1e18');
var WAD = exports.WAD = new _bignumber2.default('1e18');
var RAY = exports.RAY = new _bignumber2.default('1e27');
var RAD = exports.RAD = new _bignumber2.default('1e45');

var UINT256_MAX = exports.UINT256_MAX = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';

var AccountType = exports.AccountType = {
  PROVIDER: 'provider',
  PRIVATE_KEY: 'privateKey',
  BROWSER: 'browser'
};